
import { undoRefinement } from "./refinementThunkApi"
import { createSlice } from "@reduxjs/toolkit"


export interface IRefinementState {
  loading: "idle" | "pending" | "succeeded" | "failed"
}

export const refinementDefualtState: IRefinementState = {
  loading: "idle",
}

export const refinementSlice = createSlice({
  name: "refinement",
  initialState: refinementDefualtState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(undoRefinement.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(undoRefinement.fulfilled, (state) => {
      state.loading = "succeeded"
    })
    builder.addCase(undoRefinement.rejected, (state) => {
      state.loading = "failed"
    })
  },
})